// extracted by mini-css-extract-plugin
export var readonly = "_g7-1";
export var star = "_g7-0";